<template>
    <div class="py-4 container-fluid">
        <div class=" row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <h6>Historial de trabajos realizados </h6>
                        <h6>Operario: {{ userData.name }} </h6>
                        <!-- Columna de búsqueda -->
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label for="searchQuery" class="mb-1">Buscar</label>
                                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                                    placeholder="Buscar producción..." @input="fetchData(null)" />
                            </div>
                            <div class="col-md-6 mb-3" v-if="selectedIds.length > 0">
                                <label for="searchQuery" class="mb-1"></label>
                                <div>
                                    <button type="button" class="btn btn-success" @click="addPaid">
                                        <i class="fas fa-hand-holding-usd"></i>
                                        Pagar
                                    </button>

                                </div>
                            </div>
                           
                        </div>
                    </div>
                    <div class="card-body px-0 pt-0 pb-2">
                        <div class="table-responsive p-0">

                            <table class="table align-items-center mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" style="width: 2.5rem;">
                                            <input
                                                type="checkbox"
                                                :checked="allSelected"
                                                :indeterminate.prop="someSelected"
                                                @change="toggleSelectAll"
                                                :title="allSelected ? 'Desmarcar todos' : 'Marcar todos los pendientes'"
                                            />
                                        </th>
                                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Producción</th>
                                        <th
                                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Modelo</th>
                                        <th
                                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Oficio</th>
                                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Cant Rec</th>
                                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Cant Def</th>
                                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Cant Total</th>
                                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Precio unidad</th>

                                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Total</th>
                                        <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Total Pagado</th>
                                        <th
                                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                            Fecha</th>

                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="value in sortedData" :key="value.id">

                                        <td class="align-middle text-sm text-center">
                                            <input 
                                                v-if="value.status != 1 && value.status !== 1"
                                                style="margin: auto;" 
                                                type="checkbox" 
                                                :value="value.id" 
                                                v-model="selectedIds"
                                                />     
                                                <span v-if="value.status == 1 || value.status === 1"  style="color: forestgreen;"><i class="fa fa-check"></i></span>
                                        </td>

                                        <td class="align-middle text-sm">
                                            <h6 class="d-flex px-2 py-1 mb-0 text-sm">{{ value.production.id + " - " +
                                                value.production.name }}</h6>
                                        </td>

                                        <td class="align-middle text-center text-sm">
                                            <h6 class="mb-0 text-sm">{{ value.model?.model?.name || "Full" }}</h6>
                                        </td>

                                        <td class="align-middle text-center text-sm">
                                            <h6 class="mb-0 text-sm">{{ value.oficio?.name || "Full" }}</h6>
                                        </td>
                                        <td class="align-middle text-center text-sm">
                                            <input
                                                :disabled="value.status == 1 || value.status === 1"
                                                type="text"
                                                class="form-control"
                                                :value="value.received_quantity || 0"
                                                @blur="updateReceivedQuantity($event.target.value, value)"
                                            />
                                        </td>
                                        <td class="align-middle text-center text-sm">
                                            <input
                                                :disabled="value.status == 1 || value.status === 1"
                                                type="text"
                                                class="form-control"
                                                :value="value.rejected_quantity || 0"
                                                @blur="updateRejectedQuantity($event.target.value, value)"
                                            />
                                        </td>
                                        <td class="align-middle text-center text-sm">
                                            <h6 class="mb-0 text-sm">{{ (value.received_quantity-value.rejected_quantity) || 0 }}</h6>
                                        </td>
                                        <td class="align-middle text-center text-sm">
                                          <input
                                           :disabled="value.status == 1 || value.status === 1"
                                            type="text"
                                            class="form-control"
                                            :value="formatPrice(value.price)"
                                            @blur="updateFormattedPrice($event.target.value, value)"
                                            />

                                        </td>

                                        <td class="align-middle text-center text-sm">
                                            <h6 class="mb-0 text-sm">{{
                                                parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                                }) }}</h6>
                                        </td>

                                        
                                        <td class="align-middle text-center text-sm">
                                            <input
                                                :disabled="value.status == 1 || value.status === 1"
                                                type="text"
                                                class="form-control"
                                                :value="formatCurrency(value.total_paid || 0)"
                                                @blur="updateTotalPaid($event.target.value, value)"
                                            />
                                        </td>

                                        <td class="align-middle text-center text-sm">
                                            <h6 class="mb-0 text-sm">{{ isValidDate(value.assigned_at) ? new
                                                Date(value.assigned_at).toLocaleDateString('es-ES') : 'Sin asignar' }}
                                            </h6>
                                        </td>
                                    </tr>

                                    <tr v-if="sortedData.length === 0">
                                        <td colspan="11" class="text-center text-xxs">No hay registros disponibles</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="pagination p-3">
                                <!-- Recorremos los links para generar los botones -->
                                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer"
                                    @click="fetchData(link.url)" :disabled="!link.url || link.active"
                                    :class="{ 'active': link.label === currentPage.toString() }">
                                    {{ link.label }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';

export default {
    name: 'ProjectsList',
    data() {
        return {
            userData: {},
            selectedIds: [] 
        };
    },
    computed: {
        ...mapGetters('productionUsers', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
        currentPage() {
            return this.$store.state.productionUsers.currentPage; // Obtiene la pagina actual
        },
        lastPage() {
            return this.$store.state.productionUsers.lastPage; // Obtiene la última página
        },
        data() {
            return this.allData; // Retorna los usuarios desde el store
        },
        links() {
            return this.$store.getters['productionUsers/links']; // Retorna los links
        },
        // IDs que se pueden marcar (pendientes de pagar, status != 1)
        selectableIds() {
            return this.data.filter(v => v.status != 1 && v.status !== 1).map(v => v.id);
        },
        allSelected() {
            return this.selectableIds.length > 0 && this.selectableIds.every(id => this.selectedIds.includes(id));
        },
        someSelected() {
            const selected = this.selectableIds.filter(id => this.selectedIds.includes(id)).length;
            return selected > 0 && selected < this.selectableIds.length;
        },
        // Pendientes primero (faltan por hacer check), luego los ya pagados
        sortedData() {
            return [...this.data].sort((a, b) => {
                const aPending = (a.status != 1 && a.status !== 1) ? 0 : 1;
                const bPending = (b.status != 1 && b.status !== 1) ? 0 : 1;
                return aPending - bPending;
            });
        },
    },
    methods: {
        formatPrice(value) {
            if (!value && value !== 0) return ''
            return Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        formatCurrency(value) {
            if (!value && value !== 0) return ''
            return parseFloat(value).toLocaleString('es-ES', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        updateFormattedPrice(inputValue, value) {
            const clean = inputValue.replace(/\./g, "")
            value.price = parseFloat(clean || 0);
            this.updatePrice(value);
        },
        updateReceivedQuantity(inputValue, value) {
            const clean = inputValue.replace(/\./g, "")
            value.received_quantity = parseInt(clean || 0);
            this.updatePrice(value);
        },
        updateRejectedQuantity(inputValue, value) {
            const clean = inputValue.replace(/\./g, "")
            value.rejected_quantity = parseInt(clean || 0);
            this.updatePrice(value);
        },
        updateTotalPaid(inputValue, value) {
            // Remover puntos (separadores de miles) y reemplazar coma por punto para decimales
            let clean = inputValue.toString().replace(/\./g, "").replace(",", ".");
            // Si no hay decimales, asegurar que sea un número válido
            if (clean === '' || isNaN(clean)) {
                clean = '0';
            }
            value.total_paid = parseFloat(clean);
            this.updatePrice(value);
        },
        async fetchData(pageUrl = null) {
            const params = {
                user_id: this.userData.id,
                page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
            };
            await this.$store.dispatch('productionUsers/fetchData', params);
        },
        toggleSelectAll() {
            if (this.allSelected) {
                this.selectedIds = [];
            } else {
                this.selectedIds = [...this.selectableIds];
            }
        },
        isValidDate(date) {
            if (!date) {
                return false;
            }
            const parsedDate = new Date(date);
            return !isNaN(parsedDate.getTime());
        },
        async addPaid() {

            // Calcular el total pendiente de los seleccionados
            const totalPendiente = this.data
                .filter(value => this.selectedIds.includes(value.id)) // Filtra los seleccionados
                .reduce((sum, value) => sum + (value.total - value.total_paid), 0); // Suma los pendientes


            const { value: formValues } = await Swal.fire({
                title: "Agregar Pago",
                html: `
                <div>
                    <input id="swal-price" class="swal2-input mt-2" placeholder="Valor a pagar" style="width:100%;margin:0px" value="${totalPendiente}">
                    <textarea id="swal-observation" class="swal2-input mt-2" placeholder="Observación" style="width:100%;margin:0px;height:80px;"></textarea>
                </div>`,
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonText: "Guardar",
                cancelButtonText: "Cancelar",
                preConfirm: () => {
                const price = parseFloat(document.getElementById("swal-price").value.trim());
                const observation = document.getElementById("swal-observation").value.trim();

                if (isNaN(price) || price <= 0) {
                    Swal.showValidationMessage("El precio debe ser un número válido y positivo");
                    return false;
                }

               if( this.userData.payment==1){
                    if (isNaN(price) || price > totalPendiente) {
                        Swal.showValidationMessage("El valor asignado excede el valor de las tareas seleccionadas");
                        return false;
                    }
                }


                return { price, observation };
                },
            });

            if (formValues) {
                try {
                const payment = {
                    id: 0,
                    production_user_id: this.userData.id,
                    total: formValues.price,
                    observation: formValues.observation,
                    tasks:this.selectedIds
                };

                Swal.fire({
                    icon: 'info',
                    title: 'Cargando...',
                    text: 'Estamos obteniendo los datos, por favor espera.',
                    didOpen: () => {
                    Swal.showLoading();
                    },
                    confirmButtonText: 'Aceptar',
                    backdrop: true,
                });
                

                const response = await this.$store.dispatch("productionPayments/save", payment);

              
                
                if (response && response.status >= 200 && response.status < 300) {
                    Swal.fire("Éxito", "Pago registrado correctamente", "success");
                    // Generar el PDF del recibo de pago
                    const paymentData = response.data.data || response.data;
                    this.generateDoc(paymentData);
                    this.fetchData();
                    this.selectedIds = [];
                   
                } else {
                    throw new Error(response.data.message || "Error al registrar el pago");
                }
                } catch (error) {
                Swal.fire("Error", "No se pudo registrar el pago", "error");
                }
            }
         },
        async generateDoc(payment) {
            try {
                // Obtener el ID del pago
                const paymentId = payment.id || payment.data?.id;
                if (!paymentId) {
                    console.error("No se pudo obtener el ID del pago");
                    return;
                }
                
                // Generar el PDF
                const response = await this.$store.dispatch("productionPayments/getPdf", paymentId);
                
                // Crear una URL del archivo recibido
                const url = window.URL.createObjectURL(new Blob([response.data]));
        
                // Crear un enlace para descargar el archivo
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `Recibo_Pago_${paymentId}.pdf`); // Nombre del archivo
                document.body.appendChild(link);
                link.click();
        
                // Limpiar la URL creada
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
            } catch (error) {
                console.error("Error al generar el PDF:", error);
                await Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'Error al generar el PDF del recibo de pago',
                });
            }
        },
        async updatePrice(value) {

            value.nomina = 1;
            try {
                // Dispara la acción de Vuex para guardar el estudiante
                const response = await this.$store.dispatch("productionUsers/save", value);

                if (response && response.status >= 200 && response.status < 300) {
                    console.log("Precion actualizado");
                    this.fetchData();
                } else {
                throw new Error(response.data.message || 'Error al guardar el registro');
                }

            } catch (error) {
                console.error("Error al crear el registro:", error);
                await Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.message || 'Error al guardar el registro',
                });
            }

            },
    },
    mounted() {

        const route = useRoute();
        this.userData = route.params;

        this.fetchData(); // Llama a fetchUsers cuando el componente se monta
    },
};
</script>

<style scoped>
.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.page-item {
    margin: 0 5px;
}

.active {
    font-weight: bold;
    /* Estilo para la página activa */
}
</style>